// extracted by mini-css-extract-plugin
module.exports = {"PhantomButton":"PhantomButton_PhantomButton__KbZTx","PhantomButtonText":"PhantomButton_PhantomButtonText__WNy0K"};